/* unplugin-vue-components disabled */import __unplugin_components_0 from 'D:/workspace/space-time-web/src/components/SvgIcon/index.vue';
import { unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, isRef as _isRef, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue";
const _hoisted_1 = {
  class: "icon-body"
};
const _hoisted_2 = {
  class: "icon-list"
};
const _hoisted_3 = ["onClick"];
import icons from './requireIcons';
export default {
  __name: 'index',
  emits: ['selected'],
  setup(__props, {
    expose: __expose,
    emit: __emit
  }) {
    const iconName = ref('');
    const iconList = ref(icons);
    const emit = __emit;
    function filterIcons() {
      iconList.value = icons;
      if (iconName.value) {
        iconList.value = icons.filter(item => item.indexOf(iconName.value) !== -1);
      }
    }
    function selectedIcon(name) {
      emit('selected', name);
      document.body.click();
    }
    function reset() {
      iconName.value = '';
      iconList.value = icons;
    }
    __expose({
      reset
    });
    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");
      const _component_svg_icon = __unplugin_components_0;
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_input, {
        modelValue: _unref(iconName),
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _isRef(iconName) ? iconName.value = $event : null),
        style: {
          "position": "relative",
          "background": "rgba(30,45,71,.6)",
          "border": "none"
        },
        clearable: "",
        placeholder: "请输入图标名称",
        onClear: filterIcons,
        onInput: filterIcons
      }, {
        suffix: _withCtx(() => [...(_cache[1] || (_cache[1] = [_createElementVNode("i", {
          class: "el-icon-search el-input__icon"
        }, null, -1)]))]),
        _: 1
      }, 8, ["modelValue"]), _createElementVNode("div", _hoisted_2, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(iconList), (item, index) => {
        return _openBlock(), _createElementBlock("div", {
          key: index,
          onClick: $event => selectedIcon(item)
        }, [_createVNode(_component_svg_icon, {
          "icon-class": item,
          style: {
            "height": "3rem",
            "width": "1.6rem"
          }
        }, null, 8, ["icon-class"]), _createElementVNode("span", null, _toDisplayString(item), 1)], 8, _hoisted_3);
      }), 128))])]);
    };
  }
};